import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service'
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';





@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.css']
})
export class BanksComponent implements OnInit {
height:Number;
bank_listing:Object[];
current_page = 1;
search = "";
page = 1;
collection = [];

collection_size:Number;






  constructor(private dataservice :DataserviceService,private router:Router) { }

setHeight(){
  var windowHeight = innerHeight;
  console.log(windowHeight);
  
  var nnn = $('.header-section').innerHeight();
    var nnn1= $('.breadcrumb.breadcrumb-top').innerHeight();
    var nnn2 = $('.clearfix').innerHeight();
    this.height =innerHeight - nnn - nnn1 - nnn2 -3;
    console.log(nnn1);
    console.log(nnn2);
    console.log(this.height);
    console.log(innerHeight);
    
    
    
    
}




  
  ngOnInit(page=1,keyword="") {
    
    console.log(page,keyword);
    



    this.current_page = page;
    console.log(this.current_page);
    
    
  this.setHeight();   

   


this.dataservice.getbankList(page,keyword).subscribe(
  data =>{
    console.log(data);
    this.collection_size= data.total,

    this.bank_listing=data.banks;
    // this.userPage(data.total)

    
  }
)



  }


// bank detail function start here
showBankDetailPage(data1){
 
      this.router.navigate(['/bank-detail'], { queryParams: { id: data1 } });      
   
}


// remove banks function start here
removeBanks(data,i){
  
  
  console.log(i);
  
  console.log(this.bank_listing);
  



  Swal({
    title: 'Delete Bank',
    text: 'Are you sure,you want to remove  this bank?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if(result.value){
      this.dataservice.removeBank(data).subscribe(
        data =>{
          
          this.bank_listing.splice(i,1);
          // this.ngOnInit();
          // this.car_colors$[i].is_blocked = 1;
          console.log(data);
          
        }
      )
    }
  });  
}








userPage(data) {
  console.log(data);
  this.collection = [];
 var data1 =  Math.ceil(data/10);
//  alert(data1);
  for(let i=0;i<data1;i++) {
    this.collection.push(i);
  }
  console.log(this.collection);
}

}
